import './shared/lib/storage-migrate';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { initWebVitals } from './shared/lib/web-vitals';
import { initVisualEffects } from './shared/lib/visual-effects';
import './app/styles.css';

(function applyThemeSync() {
  try {
    const raw = localStorage.getItem('pridex-theme');
    const mode = raw ? (JSON.parse(raw)?.state?.mode as string) : 'system';
    let theme: 'light' | 'dark' = 'light';
    if (mode === 'dark') theme = 'dark';
    else if (mode === 'light') theme = 'light';
    else if (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches) theme = 'dark';
    document.documentElement.setAttribute('data-theme', theme);
  } catch {
    const systemDark =
      typeof window !== 'undefined' &&
      window.matchMedia?.('(prefers-color-scheme: dark)').matches;
    document.documentElement.setAttribute('data-theme', systemDark ? 'dark' : 'light');
  }
})();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

initWebVitals();

initVisualEffects();
